import { axiosClientMiddleware } from "config/axios/AxiosClient"
import { AxiosResponse } from "axios"
import { PolygonResponse } from "screens/ManageCoveragesScreen/types"

export const fetchPolygons = async (
  courierRecordIds: string[] | null,
  token: string,
  polygonType: string | null,
  commune: string | null = null,
): Promise<{ records: any[] | null; totalRecordsMatched: number }> => {
  try {
    const requestBody: any = {
      skipRecords: 0,
      maxRecords: 200,
      filter: {},
    }

    if (courierRecordIds && courierRecordIds.length > 0) {
      requestBody.filter.courierIds = courierRecordIds
    }

    if (polygonType && polygonType !== "all") {
      requestBody.filter.type = polygonType
    }

    if (commune) {
      requestBody.filter.route = {
        target: {
          type: "Location",
          data: {
            criteria3: commune,
          },
        },
      }
    }

    const response: AxiosResponse<PolygonResponse> = await axiosClientMiddleware.post(
      "/bff/olm/coverage_area/all",
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    )

    if (!response.data || response.data.code !== 200) {
      return { records: null, totalRecordsMatched: 0 }
    }

    if (!response.data.message?.records) {
      return { records: [], totalRecordsMatched: 0 }
    }

    const polygons = response.data.message.records.map((item) => ({
      ...item,
      name: item.id, // Ensure name is set for display purposes
      alias: item.id, // Ensure alias is set for display purposes
      type: item.type?.toLowerCase(),
    }))

    return {
      records: polygons,
      totalRecordsMatched: response.data.message.totalRecordsMatched || polygons.length,
    }
  } catch (error) {
    console.error("Error fetching polygons:", error)
    return { records: null, totalRecordsMatched: 0 }
  }
}

export const savePolygon = async (payload: any, token: string) => {
  try {
    const { axiosClientMiddleware } = require("config/axios/AxiosClient")

    // Format payload similar to maps
    const formattedPayload = {
      ...payload,
      polygon: {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [
            payload.polygon.geometry.coordinates[0].map((coord: any) =>
              Array.isArray(coord) ? [...coord] : [coord.lng, coord.lat],
            ),
          ],
        },
      },
    }

    const response = await axiosClientMiddleware.put("/bff/olm/coverage_area", formattedPayload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })

    if (!response.data || response.data.code !== 200) {
      throw new Error("Error saving polygon")
    }

    return { ...response.data }
  } catch (error) {
    throw error
  }
}

export const deletePolygons = async (
  ids: string[],
  comment: string = "Polygon deleted from monitor",
  token: string,
) => {
  try {
    const { axiosClientMiddleware } = require("config/axios/AxiosClient")

    const response = await axiosClientMiddleware.delete("/bff/olm/coverage_area", {
      data: {
        ids: [...ids],
        comment,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })

    if (!response.data || response.data.code !== 200) {
      throw new Error("Error deleting polygons")
    }

    return { ...response.data }
  } catch (error) {
    console.error("Error deleting polygons:", error)
    throw error
  }
}
